import { Health } from '@velocity-exchange/icons';
import healthDependentClassName from 'src/utils/healthDependentClassName';
import React from 'react';
import { cm } from 'src/utils/classNames';
import { WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithClassName {
	health: number;
	valueClassName?: string;
}

const HealthDisplay = ({ className, valueClassName, health }: Props) => {
	return (
		<div
			className={cm('inline-flex min-w-[60px] items-center gap-x-1', className)}
		>
			<Health
				size={16}
				color={healthDependentClassName(health, { type: 'color-var' })}
			/>
			<span
				className={cm(
					'typo-body-2xs',
					healthDependentClassName(health, { type: 'text' }),
					valueClassName
				)}
			>
				{health}%
			</span>
		</div>
	);
};

export default HealthDisplay;
